// RAW DATA parsing function
export function parseRawData(rawData) {
  if (!rawData || typeof rawData !== "string") return "";

  let result = rawData
    // decode common escapes
    .replace(/\\n/g, "\n")
    .replace(/\\t/g, "\t")
    .replace(/\\r/g, "\r")
    .replace(/\\b/g, "\b")
    .replace(/\\f/g, "\f")
    .replace(/\\"/g, '"')
    .replace(/\\'/g, "'")
    .replace(/\\\\/g, "\\")

    // decode unicode escapes (\uXXXX)
    .replace(/\\u([\dA-Fa-f]{4})/g, (match, grp) =>
      String.fromCharCode(parseInt(grp, 16))
    )

    // strip ANSI / ESC sequences
    .replace(/\u001b\[[0-9;?]*[A-Za-z]/g, "")
    .replace(/\u001b\(.\d*/g, "");

  return result.trim();
}

// Custom Tooltip component for RAW DATA
export const RawDataTooltip = ({ rawData }) => {
  const parsedData = parseRawData(rawData);

  return (
    <span
      style={{
        display: "block",
        fontFamily: "monospace",
        fontSize: "12px",
        lineHeight: "1.4",
        backgroundColor: "#f8f9fa", // light gray bg
        color: "#212529", // dark readable text
        border: "1px solid #dee2e6",
        borderRadius: "6px",
        padding: "10px 12px",
        maxHeight: "400px",
        overflowY: "auto",
        overflowX: "hidden",
        whiteSpace: "pre-wrap",
        wordBreak: "break-word",
        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)", // subtle shadow
      }}
      className="fancy-scroll" // optional custom scroll styling
    >
      {parsedData || "No RAW DATA available"}
    </span>
  );
};
